import { getVarsoUrl } from "./helpers";

export default function getMasterMindLink(variant, ref, suffix) {
  const masterminds = [];
  if (Array.isArray(variant.genomenon_mastermind)) {
    variant.genomenon_mastermind.forEach((item) => {
      const mmids = item.mmid3;
      const identifiersAndUrls = [];
      if (mmids) {
        mmids.forEach((mmid) => {
          let geneSymbol = null;
          const parts = mmid.split(":");
          const aaParts = [];
          const fullParts = [];
          if (parts.length === 2) {
            // eslint-disable-next-line prefer-destructuring
            geneSymbol = parts[0];
            aaParts.push(parts[1]);
            fullParts.push(mmid);
          }
          if (aaParts.length > 0) {
            let queryString;
            if (aaParts.length > 1) {
              queryString = `&boolean=true&gene_op=and&disease_op=and&mutation_op=or&mutation=${fullParts
                .map((p) => p.toUpperCase())
                .join("&mutation=")}`;
            } else {
              queryString = `&mutation=${aaParts[0]}`;
            }
            identifiersAndUrls.push({
              identifier: mmid,
              url: getVarsoUrl(
                `https://mastermind.genomenon.com/detail?disease=all%20diseases&gene=${geneSymbol}${queryString}&ref=${ref}${suffix}`
              ),
            });
          }
        });
      }

      const add = {
        identifiers: identifiersAndUrls,
        mmcnt: item.mmcnt3,
        version: item.version,
      };
      masterminds.push(add);
    });
  }
  return masterminds.length > 0 ? masterminds : null;
}
